import { render } from "./AddTypeMediaModal.vue?vue&type=template&id=0a0f70a6&ts=true"
import script from "./AddTypeMediaModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeMediaModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__